// Analytics configuration for NettoiGo
export const ANALYTICS_CONFIG = {
  // Google Analytics / Google Ads Measurement ID
  GOOGLE_ANALYTICS_ID: "AW-17145656514",

  // Environment-specific settings
  IS_PRODUCTION: import.meta.env.PROD,
  IS_DEVELOPMENT: import.meta.env.DEV,

  // Enable/disable different analytics providers
  ENABLE_GOOGLE_ANALYTICS: true,
  ENABLE_SWETRIX: true,
  ENABLE_FACEBOOK_PIXEL: true,

  // Debug logging (only in development)
  DEBUG_ANALYTICS: import.meta.env.DEV,
} as const;
